import axios from 'axios';

type PayloadLogin = {
  email: string;
  password: string;
};
export const login = async (payload: PayloadLogin) => {
  const { data } = await axios.post('/auth/admin/signin', payload);
  return data;
};

export const forgotPassword = async (email: string) => {
  const { data } = await axios.post('/auth/forgot-password', { email });
  return data;
};
type PayloadResetPassword = {
  password: string;
  code: string;
};
export const resetPassword = async (payload: PayloadResetPassword) => {
  const { data } = await axios.post('/auth/reset-password', payload);
  return data;
};

type PayloadChangePassword = {
  newPassword: string;
  currentPassword: string;
};

export const changeInfo = async (payload: PayloadChangePassword) => {
  const { data } = await axios.put('/auth/change-password', payload);
  return data;
};

export const getInfoUser = async () => {
  const { data } = await axios.get('/auth/me');
  return data;
};
